<div class="top-section">
    <h6 class="heading mb-0">{{ ss.t('deleteAccount_title') }}</h6>
    <app-svg name="close" role="button" (click)="closeDialog()"></app-svg>
</div>
<div class="delete-form">
    <div>
        <div class="ri-p-4 bg-11">
            <p class="text-14-400 color-12 mb-0">{{ ss.t('deleteAccount_content') }}</p>
        </div>
        <form class="ri-p-4" (ngSubmit)="$event.preventDefault()">
            <div class="flex justify-between items-center" [matMenuTriggerFor]="deleteReasonMenu" role="button">
                <div class="flex items-center">
                    <app-svg name="featureWithoutPadding" [color]="ss.theme().color35" class="ri-me-4"></app-svg>
                    <p class="text-16-400 mb-0 ri-ms-3" [ngClass]="getFc('reason').value ? 'color-8' : 'color-7'">{{
                        getFc('reason').value ? getReason?.reason : ss.t('deleteAccount_reasonSelectPlaceholder')
                        }}</p>
                    <mat-menu #deleteReasonMenu="matMenu" class="me-menu info-menu">
                        <button mat-menu-item (click)="selectReason(reason.id)" *ngFor="let reason of deleteReasons()">
                            <span class="text-14-400 color-8">{{reason.reason}}</span>
                        </button>
                    </mat-menu>
                </div>
                <app-svg name="downArrow" [color]="ss.theme().color35"></app-svg>
            </div>


            <app-input-text-editor class="ri-pt-6" [control]="getFc('feedback')" name="meDeleteAccountFeedback"
                [placeholder]="ss.t('deleteAccount_feedbackAddPlaceholder')"></app-input-text-editor>

            <!-- <pre class="color-8">{{deleteForm.value | json}} {{ deleteForm.invalid }}</pre> -->
        </form>
    </div>
    <div class="delete-addons ri-px-4 ri-py-2 ri-bt-2" *ngIf="!deleteForm.invalid">
        <p class="text-12-400 color-35 mb-0 underline" (click)="openPolicy('TERMS_OF_USE')" role="button">{{
            ss.t('common_termsAndConditions') }}</p>
        <p class="text-12-400 color-7 mb-0 ri-pt-2">{{ ss.t('deleteAccount_termsAndConditionsInfo') }}</p>
    </div>
</div>
<div class="bottom-section flex items-center justify-end ri-p-4 ri-bt-2">
    <button type="submit" class="btn-text text-16-500 color-7 ri-me-6" (click)="closeDialog()">{{
        ss.t('common_buttonCancel') }}</button>
    <button type="submit" class="btn-text text-16-500 color-11 check-disabled" (click)="deleteConfirm()"
        [disabled]="deleteForm.invalid">{{ ss.t('common_delete') }}</button>
</div>